const config = {};

// MAJOREL DEV AZURE AUTH
config.clientId =
  process.env.REACT_APP_MAJOREL_AUTH_CLIENTID ??
  "a4889061-bb91-4578-9cdb-4aa0d232597b";
config.tenantId =
  process.env.REACT_APP_MAJOREL_AUTH_TENANTID ??
  "0df119c8-23ea-40d9-8dda-62d4a4db8dfb";

// majorel PROD AZURE AUTH
// majorel azure auth

/*
config.clientId =
  process.env.REACT_APP_MAJOREL_AUTH_CLIENTID ??
  "203b3ace-75f8-4ed7-9883-7d71e849bdda";
config.tenantId =
  process.env.REACT_APP_MAJOREL_AUTH_TENANTID ??
  "0df119c8-23ea-40d9-8dda-62d4a4db8dfb";*/

config.redirectUri =
  process.env.REACT_APP_REDIRECT_URI ?? "http://localhost:3000/";
config.postLogoutURL = config.redirectUri + "postLogout";

// dev
// majorel's dev backend in their azure org when working locally
config.baseURL =
  process.env.REACT_APP_BACKEND_URL ??
  "https://backend-easa-gee-de-genesys-dev.azurewebsites.net";

// majorel's backend in their azure org
/*config.baseURL =
  process.env.REACT_APP_BACKEND_URL ??
  "https://backend-easa-gee-de-genesys-dev.azurewebsites.net";*/

// production
/*config.baseURL =
  process.env.REACT_APP_BACKEND_URL ??
  "https://backend-easa-gee-de-genesys-prod.azurewebsites.net";*/

// phase 2 env
/*config.baseURL =
  process.env.REACT_APP_BACKEND_URL ??
  "https://multidev-backendproxy.azurewebsites.net";*/

// client id of phase 2
/*config.clientId =
  process.env.REACT_APP_MAJOREL_AUTH_CLIENTID ??
  "2940d6d8-5e3f-4ca7-acb4-b6ce50962f0a";*/

export default config;
